export default "__VITE_ASSET__da622dc9__"